import { render, staticRenderFns } from "./DailyCoupon.vue?vue&type=template&id=4520e8ca&"
import script from "./DailyCoupon.vue?vue&type=script&lang=js&"
export * from "./DailyCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports